import React, { useEffect } from "react";

const PlausibleAnalytics = (): React.ReactElement | null => {
  useEffect(() => {
    const isProduction = import.meta.env.VERCEL_ENV === "production";
    if (isProduction) {
      const script = document.createElement("script");
      script.defer = true;
      script.setAttribute("data-domain", "playground.pluto.xyz");
      script.src = "https://plausible.io/js/script.js";
      document.head.appendChild(script);

      return () => {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
      };
    }
  }, []);

  return null;
};

export default PlausibleAnalytics;
